// No.8 定型文 — クライアント提供文言
// 追加・変更は本ファイルの MEMO_TEMPLATES を編集してデプロイする。

export const MEMO_TEMPLATES = [
  {
    id: 'observation',
    label: '【経過観察】',
    body: '現時点では緊急性はないため経過観察とする。2時間後バイタル再検し状態変化時はご連絡いただくようお伝えする。',
  },
  {
    id: 'emergency-transport',
    label: '【救急搬送】',
    body: 'お見取りの方ではないため救急搬送を依頼する。',
  },
  {
    id: 'fever',
    label: '【発熱】',
    body: 'カロナール内服し頭部・両鼠径の3点クーリングを依頼。',
  },
  {
    id: 'vomiting',
    label: '【嘔吐】',
    body: '再度嘔吐する可能性ありベッドアップし側臥位で過ごしていただくようお伝えする。',
  },
]

export const appendMemoTemplate = (currentMemo, templateBody) => {
  const current = (currentMemo || '').trimEnd()
  const body = (templateBody || '').trim()
  if (!body) return currentMemo || ''
  if (!current) return body
  return `${current}\n${body}`
}
